import React, { useState } from "react";
import MRadio from "../../components/ui/atoms/MRadio";

const RadioTest: React.FC = () => {
  const [selected, setSelected] = useState("one");
  return (
    <div style={{ padding: 32 }}>
      <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>MRadio States</h2>
      <div style={{ display: "flex", gap: 32 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <MRadio checked={false} name="radio-demo" />
          <span style={{ marginTop: 8 }}>Unselected</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <MRadio checked name="radio-demo" />
          <span style={{ marginTop: 8 }}>Selected</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <MRadio checked={false} disabled name="radio-demo" />
          <span style={{ marginTop: 8 }}>Unselected Disabled</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <MRadio checked disabled name="radio-demo1" />
          <span style={{ marginTop: 8 }}>Selected Disabled</span>
        </div>
      </div>
      <div style={{ height: 40 }} />
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>Interactive Example</h2>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <MRadio checked={selected === "one"} name="group" onChange={() => setSelected("one")}/>
        <span>Option 1</span>
        <MRadio checked={selected === "two"} name="group" onChange={() => setSelected("two")}/>
        <span>Option 2</span>
        <MRadio checked={selected === "three"} name="group" onChange={() => setSelected("three")}/>
        <span>Option 3</span>
      </div>
    </div>
  );
};

export default RadioTest;
